import React,{ Component } from 'react'
import { TimelineMax } from 'gsap'
import GSAP from 'react-gsap-enhancer'


function createAnimation(){
  const duration = 2;
  const stagger_val = 0.004;
  const tl = new TimelineMax()
  const tl_color = new TimelineMax({
      repeat: -1,
      repeatDelay: 0,
      yoyo: true
  })
  const target = document.getElementById('to-pixel');
  const child_nodes = target.childNodes;
  // ie11 forEach用
  const child_nodes_arr = Array.prototype.slice.call(child_nodes,0); 
  const colors = ["#0a549d","#0a549d","#0a549d","#0a549d", "#1469af", "#69a4a3","#4181bf","#e84a65","#8179ac","#6da0d2","#bbb","#e5dd5c",];
  child_nodes_arr.forEach((val,key) => {
    tl.set(val,{
      x: '+=' + getRandom(-10,10),
      y: '+=' + getRandom(-10,10),
      rotation: '+=' + getRandom(-240,240),
      opacity: 0
    })
    // init color
    val.style.fill = getArrayRandom(colors)
  })
  const tl_to = {
    x:0,
    y:0,
    rotation:0,
    opacity: 1,
    ease: "Power4.easeInOut"
  }
  // color
  const list = target;
  for (var i = child_nodes_arr.length; i >= 0; i--) {
      list.appendChild(child_nodes[Math.random() * i | 0]);
  }
  tl_color.staggerTo(child_nodes,0.3, {
    cycle:{
      fill:function(index){
        return getArrayRandom(colors)
      }
    }
  }, 0.01)
  return tl.staggerTo(child_nodes, duration, tl_to, stagger_val);
}
function getRandom(min, max) {
  return Math.random() * (max - min) + min;
}
function getArrayRandom(list){
  return list[Math.floor(Math.random() * list.length)];
}


class To1px extends Component {
  constructor(props){
    super(props)
    this.state = {
      repeat:0,
      repeatDelay:0,
      yoyo:false
    }
  }
  
  componentDidMount(){
    this.addAnimation(createAnimation)
  }
  render(){
    return (
      <figure>
        <svg version="1.1" id="to-pixel" xmlns="http://www.w3.org/2000/svg"  x="0px"
            y="0px" viewBox="0 0 210 130">
        <rect x="177.283" y="101.833" className="px0" width="5" height="5"/>
<rect x="172.283" y="101.833" className="px0" width="5" height="5"/>
<rect x="167.283" y="101.833" className="px0" width="5" height="5"/>
<rect x="162.283" y="101.833" className="px0" width="5" height="5"/>
<rect x="157.283" y="96.833" className="px0" width="5" height="5"/>
<rect x="157.283" y="91.833" className="px0" width="5" height="5"/>
<rect x="157.283" y="86.833" className="px0" width="5" height="5"/>
<rect x="157.283" y="81.833" className="px0" width="5" height="5"/>
<rect x="157.283" y="76.833" className="px0" width="5" height="5"/>
<rect x="157.283" y="71.833" className="px0" width="5" height="5"/>
<rect x="147.283" y="101.833" className="px0" width="5" height="5"/>
<rect x="147.283" y="86.833" className="px0" width="5" height="5"/>
<rect x="147.283" y="71.833" className="px0" width="5" height="5"/>
<rect x="142.283" y="101.833" className="px0" width="5" height="5"/>
<rect x="142.283" y="86.833" className="px0" width="5" height="5"/>
<rect x="142.283" y="71.833" className="px0" width="5" height="5"/>
<rect x="137.283" y="101.833" className="px0" width="5" height="5"/>
<rect x="137.283" y="86.833" className="px0" width="5" height="5"/>
<rect x="137.283" y="71.833" className="px0" width="5" height="5"/>
<rect x="132.283" y="101.833" className="px0" width="5" height="5"/>
<rect x="132.283" y="86.833" className="px0" width="5" height="5"/>
<rect x="132.283" y="71.833" className="px0" width="5" height="5"/>
<rect x="127.283" y="101.833" className="px0" width="5" height="5"/>
<rect x="127.283" y="96.833" className="px0" width="5" height="5"/>
<rect x="127.283" y="91.833" className="px0" width="5" height="5"/>
<rect x="127.283" y="86.833" className="px0" width="5" height="5"/>
<rect x="127.283" y="81.833" className="px0" width="5" height="5"/>
<rect x="127.283" y="76.833" className="px0" width="5" height="5"/>
<rect x="127.283" y="51.833" className="px0" width="5" height="5"/>
<rect x="127.283" y="46.833" className="px0" width="5" height="5"/>
<rect x="127.283" y="41.833" className="px0" width="5" height="5"/>
<rect x="127.283" y="37.833" className="px0" width="5" height="4"/>
<rect x="127.283" y="32.833" className="px0" width="5" height="5"/>
<rect x="122.283" y="56.833" className="px0" width="5" height="5"/>
<rect x="122.283" y="27.833" className="px0" width="5" height="5"/>
<rect x="118.283" y="101.833" className="px0" width="4" height="5"/>
<rect x="118.283" y="96.833" className="px0" width="4" height="5"/>
<rect x="118.283" y="76.833" className="px0" width="4" height="5"/>
<rect x="118.283" y="71.833" className="px0" width="4" height="5"/>
<rect x="118.283" y="56.833" className="px0" width="4" height="5"/>
<rect x="118.283" y="27.833" className="px0" width="4" height="5"/>
<rect x="113.283" y="91.833" className="px0" width="5" height="5"/>
<rect x="113.283" y="86.833" className="px0" width="5" height="5"/>
<rect x="113.283" y="81.833" className="px0" width="5" height="5"/>
<rect x="113.283" y="56.833" className="px0" width="5" height="5"/>
<rect x="113.283" y="27.833" className="px0" width="5" height="5"/>
<rect x="108.283" y="86.833" className="px0" width="5" height="5"/>
<rect x="108.283" y="51.833" className="px0" width="5" height="5"/>
<rect x="108.283" y="46.833" className="px0" width="5" height="5"/>
<rect x="108.283" y="41.833" className="px0" width="5" height="5"/>
<rect x="108.283" y="37.833" className="px0" width="5" height="4"/>
<rect x="108.283" y="32.833" className="px0" width="5" height="5"/>
<rect x="103.283" y="91.833" className="px0" width="5" height="5"/>
<rect x="103.283" y="86.833" className="px0" width="5" height="5"/>
<rect x="103.283" y="81.833" className="px0" width="5" height="5"/>
<rect x="98.283" y="101.833" className="px0" width="5" height="5"/>
<rect x="98.283" y="96.833" className="px0" width="5" height="5"/>
<rect x="98.283" y="76.833" className="px0" width="5" height="5"/>
<rect x="98.283" y="71.833" className="px0" width="5" height="5"/>
<rect x="98.283" y="27.833" className="px0" width="5" height="5"/>
<rect x="93.283" y="27.833" className="px0" width="5" height="5"/>
<rect x="88.283" y="101.833" className="px0" width="5" height="5"/>
<rect x="88.283" y="96.833" className="px0" width="5" height="5"/>
<rect x="88.283" y="91.833" className="px0" width="5" height="5"/>
<rect x="88.283" y="86.833" className="px0" width="5" height="5"/>
<rect x="88.283" y="81.833" className="px0" width="5" height="5"/>
<rect x="88.283" y="76.833" className="px0" width="5" height="5"/>
<rect x="88.283" y="71.833" className="px0" width="5" height="5"/>
<rect x="88.283" y="56.833" className="px0" width="5" height="5"/>
<rect x="88.283" y="51.833" className="px0" width="5" height="5"/>
<rect x="88.283" y="46.833" className="px0" width="5" height="5"/>
<rect x="88.283" y="41.833" className="px0" width="5" height="5"/>
<rect x="88.283" y="37.833" className="px0" width="5" height="4"/>
<rect x="88.283" y="32.833" className="px0" width="5" height="5"/>
<rect x="88.283" y="27.833" className="px0" width="5" height="5"/>
<rect x="83.283" y="27.833" className="px0" width="5" height="5"/>
<rect x="78.283" y="81.833" className="px0" width="5" height="5"/>
<rect x="78.283" y="76.833" className="px0" width="5" height="5"/>
<rect x="78.283" y="27.833" className="px0" width="5" height="5"/>
<rect x="73.283" y="86.833" className="px0" width="5" height="5"/>
<rect x="73.283" y="71.833" className="px0" width="5" height="5"/>
<rect x="68.283" y="86.833" className="px0" width="5" height="5"/>
<rect x="68.283" y="71.833" className="px0" width="5" height="5"/>
<rect x="63.283" y="86.833" className="px0" width="5" height="5"/>
<rect x="63.283" y="71.833" className="px0" width="5" height="5"/>
<rect x="58.283" y="101.833" className="px0" width="5" height="5"/>
<rect x="58.283" y="96.833" className="px0" width="5" height="5"/>
<rect x="58.283" y="91.833" className="px0" width="5" height="5"/>
<rect x="58.283" y="86.833" className="px0" width="5" height="5"/>
<rect x="58.283" y="81.833" className="px0" width="5" height="5"/>
<rect x="58.283" y="76.833" className="px0" width="5" height="5"/>
<rect x="58.283" y="71.833" className="px0" width="5" height="5"/>
<rect x="43.283" y="101.833" className="px0" width="5" height="5"/>
<rect x="43.283" y="96.833" className="px0" width="5" height="5"/>
<rect x="43.283" y="91.833" className="px0" width="5" height="5"/>
<rect x="43.283" y="86.833" className="px0" width="5" height="5"/>
<rect x="43.283" y="81.833" className="px0" width="5" height="5"/>
<rect x="43.283" y="76.833" className="px0" width="5" height="5"/>
<rect x="43.283" y="71.833" className="px0" width="5" height="5"/>
<rect x="38.283" y="76.833" className="px0" width="5" height="5"/>
        </svg>
      </figure>
    )
  }
}
export default GSAP()(To1px)



// WEBPACK FOOTER //
// ./src/component/home/to1px.js